import { SiJavascript,
    SiReact, 
    SiPython,
    SiHtml5,
    SiCss3,
    SiDjango,
    SiBootstrap,
    SiReactos,
    SiTailwindcss,
    SiGit,
    SiGithub,
} from "react-icons/si";

export const projects = [
{
   key: "climateCircles",
   title: "Climate Circles",
   subtitle: "HTML, CSS",
   description: "Website for a psychologist that hosts workshops and climate circles",
   image: "./assets/climate-circles.gif",
   link: "https://teodoraalina.github.io/climate-circles/",
   github: "https://github.com/TeodoraAlina/climate-circles",
},

{
   key: "restaurantDelivery",
   title: "Pasta La Vista",
   subtitle: "Python, Google APIs",
   description: "Command-line application created for a restaurant's food delivery platform",
   image: "./assets/pasta-la-vista.gif",
   link: "https://pasta-la-vista.herokuapp.com/",
   github: "https://github.com/TeodoraAlina/pasta-la-vista",
},

{
   key: "vacay",
   title: "Smells like Vacay",
   subtitle: "HTML, CSS, JavaScript, Python, Django, Bootstrap CSS",
   description: "Smells Like Vacay is a user-friendly packing list application designed to simplify your vacation preparations.",
   image: "./assets/start-packing.gif",
   link: "https://start-packing-6d194f35b54b.herokuapp.com/",
   github: "https://github.com/TeodoraAlina/start-packing",
},

{
   key: "coolTheEarth",
   title: "Cool the Earth",
   subtitle: "HTML, CSS, JavaScript, ReactJS, Django Rest Framework, React Bootstrap",
   description: "Cool the Earth is a social media platform committed to driving positive change to our environment.",
   image: "./assets/cool-the-earth.gif",
   link: "https://cool-the-earth-2122f9015977.herokuapp.com/",
   github: "https://github.com/TeodoraAlina/cool-the-earth",
}
];

export const collaborativeProjects = [
   {
     key: "theLoversBlog",
     subtitle: "HTML5, CSS, JavaScript, Python, Django, JQuery",
     title: "The Lovers Blog",
     description: "A Valentine's-themed hackathon project by Cupid-Devils, allowing users to post tips for a better love life.",
     image: "./assets/lovers-blog.jpg",
     link: "",
     github: "https://github.com/TeodoraAlina/cupid_devils"
   },
   {
      key: "happyHacks",
      subtitle: "HTML5, CSS, JavaScript, Python, Django, Bootstrap, EmojiMart",
      title: "Happy Hacks",
      description: "Happy Hacks offers motivational tips to boost happiness. Users can view random tips, create their own, and interact with others posts.",
      image: "./assets/happy-hacks.gif",
      link: "https://happiness-generator-c0a5ad8756d8.herokuapp.com",
      github: "https://github.com/TeodoraAlina/happiness"
    },
    {
      key: "neuroSisters",
      subtitle: "HTML, CSS, JavaScript, Python, Flask, Django, Bootstrap5",
      title: "Neuro Sisters",
      description: "A site for women caring for neurodivergent adults, providing support, resources, and a community for health and wellness.",
      image: "./assets/neuro-sisters.gif",
      link: "https://neuro-sisters-37c8c20181fb.herokuapp.com",
      github: "https://github.com/TeodoraAlina/neuro-sisters"
    },
    {
      key: "starQuiz",
      subtitle: "HTML, CSS, JavaScript, Python, Django, Tailwind CSS",
      title: "Star Quiz",
      description: "A Star Wars quiz that guides you through planets visited by Luke Skywalker.",
      image: "./assets/star-quiz.jpg",
      link: "",
      github: "https://github.com/TeodoraAlina/StarQuiz"
    },
 ];

export const skills = [
{ name: "JavaScript", icon: SiJavascript },
{ name: "Python", icon: SiPython },
{ name: "HTML", icon: SiHtml5 },
{ name: "CSS", icon: SiCss3 },
{ name: "React", icon: SiReact },
{ name: "Django", icon: SiDjango },
{ name: "Django Rest Framework", icon: SiDjango },
{ name: "Bootstrap", icon: SiBootstrap },
{ name: "React Bootstrap", icon: SiReactos },
{ name: "Tailwind CSS", icon: SiTailwindcss },
{ name: "Github", icon: SiGithub },
{ name: "Git", icon: SiGit},
];